import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'Components/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { resetHRBetSlip } from 'Store/actions/horseRacing/betSlipActions';
import { classnames } from 'Utils/classnames';


const subMenuItems =  [
  {
    name: 'Müşterek Bahis',
    icon: 'svgMenuHorse',
    link: '/tjk/at-yarisi-bulteni',
  },
  {
    name: 'Sabit İhtimalli Bahis',
    icon: 'svgMenuFixed',
    link: '/tjk/sabit-ihtimalli-at-yarisi-bulteni',
  },
  {
    name: 'Sonuçlar',
    icon: 'svgMenuResults',
    link: '/tjk/at-yarisi-sonuclari'
  },
  {
    name: 'Yazarlar',
    icon: 'svgMenuAuthors',
    link: '/tjk/at-yarisi-tahminleri'
  },
  {
    name: 'TJK TV İzle',
    icon: 'svgMenuTv',
    link: '/tjk/tjk-tv-canli-izle'
  },
  {
    name: 'Muhtemel/AGF',
    icon: 'svgMenuAgf',
    link: '/tjk/muhtemeller'
  },
  {
    name: 'Yaklaşan Koşular',
    icon: 'svgMenuUpcoming',
    link: '/tjk/yaklasan-kosular'
  },
  {
    name: 'Raporlu & Cezalı Jokeyler',
    icon: 'svgMenuReportedSuspended',
    link: '/tjk/raporlu-cezali-jokeyler',
    query: 'selectedTab=reported'
  },

];

const TjkSubMenu = () => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const subMenuRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);

  const checkScrollPosition = () => {
    if (!subMenuRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = subMenuRef.current;
    const isAtStart = scrollLeft <= 0;
    const isAtEnd = scrollLeft >= scrollWidth - clientWidth - 1;
    const hasOverflow = scrollWidth > clientWidth;

    setShowLeftArrow(hasOverflow && !isAtStart);
    setShowRightArrow(hasOverflow && !isAtEnd);
  };

  const scrollLeft = () => {
    if (subMenuRef.current) {
      subMenuRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (subMenuRef.current) {
      subMenuRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    checkScrollPosition();
    const subMenu = subMenuRef.current;
    subMenu.addEventListener('scroll', checkScrollPosition);
    window.addEventListener('resize', checkScrollPosition);

    return () => {
      subMenu.removeEventListener('scroll', checkScrollPosition);
      window.removeEventListener('resize', checkScrollPosition);
    };
  }, []);

  return (
    <div className="tjk-sub-menu-container">
      { showLeftArrow && (
        <div className="arrow left" onClick={ scrollLeft }>
          <Icon iconName="svgSubMenuArrow"/>
        </div>
      ) }
      { showRightArrow && (
        <div className="arrow right" onClick={ scrollRight }>
          <Icon iconName="svgSubMenuArrow"/>
        </div>
      ) }
      <div className="sub-menu" ref={ subMenuRef }>
        { subMenuItems.map((item, index) => <Link onClick={ e => {

          if (item?.path === '/tjk/at-yarisi-bulteni') {
            if (programType === PROGRAM_TYPES.FIXED) dispatch(resetHRBetSlip());
          }
          if (item?.path === '/tjk/sabit-ihtimalli-at-yarisi-bulteni') {
            if (programType === PROGRAM_TYPES.JOINT) dispatch(resetHRBetSlip());
          }
        } } to={ `${item.link}${item.query ? `?${item.query}` : ''}` } key={ index } className={ classnames({
          'sub-menu-item': true,
          selected: history?.location?.pathname?.includes(item.link)
        }) }>
          <Icon iconName={ item.icon }/>{ item.name }
        </Link>) }
      </div>
    </div>
  );
};

export default TjkSubMenu;
